// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-exist-wrapper{margin:20px auto;max-width:800px}\n", ""]);
// Exports
module.exports = exports;
